import React from "react";
import * as ButtonStyles from "../../../../styles/v2/lexus/components/Button";

type ButtonProps = {
    href?: string;
    onClick?: (event: any) => void;
    disabled?: boolean;
    fullWidth?: boolean;
    target?: string;
    rel?: string;
    classNames?: string;
    children: React.ReactNode;
};

const ButtonOutlineLight = (props: ButtonProps): JSX.Element => {
    const { href, onClick, disabled, fullWidth, children, target, classNames, rel } = props;
    return (
        <ButtonStyles.ButtonOutlineLight
            as={href ? "a" : "button"}
            role={href ? "link" : "button"}
            href={href && !disabled ? href : undefined}
            type={!href ? "button" : undefined}
            className={[classNames || "", disabled ? "disabled" : ""].join(" ")}
            disabled={!href && disabled}
            aria-disabled={disabled || undefined}
            m={0}
            p={0}
            target={target}
            rel={href && rel}
            fullWidth={fullWidth}
            onClick={onClick}
        >
            {children}
        </ButtonStyles.ButtonOutlineLight>
    );
};

export default ButtonOutlineLight;
